import { Link } from "react-router-dom";
import type { Streamer } from "@/types/content";

interface StreamerCardProps {
  streamer: Streamer;
}

export default function StreamerCard({ streamer }: StreamerCardProps) {
  return (
    <Link
      to={`/detail/${streamer.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-accent-300 transition-colors h-full"
    >
      <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-100">
        <img
          src={streamer.avatar}
          alt={`${streamer.name} ${streamer.type}写真`}
          title={`${streamer.name} 韩国女主播`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-600 text-background-50">
          {streamer.type}
        </span>
        <span className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-accent-600">
          <i className="ri-fire-fill"></i>
          {streamer.heat}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-foreground-950/80 to-transparent">
          <p className="text-background-50 font-heading font-bold text-lg">{streamer.name}</p>
          <p className="text-background-200/90 text-xs">{streamer.nameEn}</p>
        </div>
      </div>
      <div className="flex flex-col flex-1 p-4">
        <p className="text-sm font-medium text-foreground-900 mb-1">
          <i className="ri-tv-2-line text-accent-500 mr-1"></i>
          {streamer.program}
        </p>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">{streamer.bio}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {streamer.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full text-[11px] bg-secondary-100 text-secondary-700">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/70 text-xs text-foreground-500">
          <span>
            <i className="ri-map-pin-line mr-0.5"></i>
            {streamer.region}
          </span>
          <span>
            <i className="ri-user-heart-line mr-0.5"></i>
            {streamer.followers}
          </span>
        </div>
      </div>
    </Link>
  );
}